<template>
  <div class="mypinglun" @mousewheel.prevent>
    <div class="mypinglun-bg" @click="kk()"></div>
    <div class="mypinglun-div">
      <textarea type="text" class="mypinglun-txt" placeholder="我说了你们不信" v-model="commentdata"></textarea>
      <div class="mypinglun-div-div" v-if="tomycomment=='1'">
        <p class="mypinglun-div-div-p">评论小于五个字</p>
      </div>
      <div class="mypinglun-div-div">
        <button type="button" class="mypinglun-div-div-btn" @click="tocomment()">发布评论</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      centerDialogVisible: false,
      commentdata: "",
      tomycomment: ""
    };
  },
  methods: {
    tocomment() {
      if (this.commentdata.length < 5) {
        this.tomycomment = "1";
        setTimeout(res => {
          this.tomycomment = "0";
        }, 2000);
      } else {
        this.$http
          .post("comment/setone", {
            id: this.$route.query.id,
            type: "book",
            content: this.commentdata,
            token: this.$cookies.get("token")
          })
          .then(res => {
            if (res.data.code == 1) {
              this.$router.go(0);
            }
          });
      }
    },
    kk() {
      this.$emit("fun", this.centerDialogVisible);
    }
  },

  mounted() {}
};
</script>

<style>
.mypinglun {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  align-items: center;
}
.mypinglun-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.3;
  position: absolute;
}
.mypinglun-div {
  width: 850px;
  height: 394px;
  padding: 30px 20px;
  background-color: #fff;
  z-index: 100;
  box-sizing: border-box;
  border-radius: 8px;
}
.mypinglun-txt {
  width: 680px;
  height: 260px;
  border-radius: 8px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
  box-sizing: border-box;
  font-size: 12px;
}
.mypinglun-div-div {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.mypinglun-div-div-p {
  font-size: 12px;
  color: #cc2929;
}
.mypinglun-div-div-btn {
  width: 80px;
  height: 32px;
  background: rgba(40, 163, 177, 1);
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/publicpinglun.vue